import { render } from "./SupplierIntegrationCard.vue?vue&type=template&id=fc68b2aa&scoped=true"
import script from "./SupplierIntegrationCard.vue?vue&type=script&lang=js"
export * from "./SupplierIntegrationCard.vue?vue&type=script&lang=js"

import "./integration-card.css?vue&type=style&index=0&id=fc68b2aa&scoped=true&lang=css&external"
import "./SupplierIntegrationCard.vue?vue&type=style&index=1&id=fc68b2aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc68b2aa"]])

export default __exports__